import { useState } from "react";
import { SplatCheckoutDocumentType } from "../../../amplify/backend/function/OfferExpCheckout/ts/public/types";
import { signDocument } from "services/prospect";
import { Mixpanel } from "providers/mixpanel";
import {
  CUSTOMER_SELF_CHECKOUT__CLICKED_TEXT_MESSAGE_DOCUMENT_IN_MODAL_CHECKOUT,
  CUSTOMER_SELF_CHECKOUT__COMBINED_SIGN_ERROR,
  SALES_REP_CHECKOUT__COMBINED_SIGN_ERROR,
} from "constants/mixpanelEvents";

const useSendDocumentSMS = ({
  authKey,
  prospectId,
  proposalId,
  documentType,
  primaryContactId,
  secondaryContactId,
  isCustomer,
  docName,
  combinedAgreement = false,
}: {
  authKey: string;
  prospectId: string;
  proposalId: string;
  primaryContactId: string;
  secondaryContactId?: string;
  documentType?: SplatCheckoutDocumentType;
  isCustomer?: boolean;
  docName: string;
  combinedAgreement?: boolean;
}) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [error, setError] = useState();

  const closeSuccessMessage = () => setSuccessMessage("");

  const sendSMS = async () => {
    if (isCustomer) {
      Mixpanel.track(
        CUSTOMER_SELF_CHECKOUT__CLICKED_TEXT_MESSAGE_DOCUMENT_IN_MODAL_CHECKOUT,
        {
          prospectId,
          documentType,
          docName,
          proposalId,
          combinedAgreement,
        }
      );
    }
    setLoading(true);
    setSuccess(false);
    setError(undefined);
    try {
      await signDocument(
        {
          authKey,
          prospectId,
          proposalId,
          eSignatureSource: "Sales Platform",
          eSignatureType: "SMS",
          primaryContactId,
          ...(combinedAgreement
            ? { combinedAgreement: true }
            : {
                documentType,
              }),
        },
        secondaryContactId,
        undefined,
        isCustomer
      );

      setSuccessMessage("Text message sent successfully!");
      setSuccess(true);
    } catch (error: any) {
      if (combinedAgreement) {
        Mixpanel.track(
          isCustomer
            ? CUSTOMER_SELF_CHECKOUT__COMBINED_SIGN_ERROR
            : SALES_REP_CHECKOUT__COMBINED_SIGN_ERROR,
          {
            prospectId,
            documentType,
            docName,
            proposalId,
            error: error.message,
          }
        );
      }
      setSuccess(false);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    sendSMS,
    loading,
    success,
    successMessage,
    closeSuccessMessage,
    error,
  };
};

export { useSendDocumentSMS };
